<template>
  <router-link
    :to="to"
    class="nav-link-item"
    active-class="nav-link-item--active"
    :title="collapsed ? navText : ''"
  >
    <span class="nav-link-icon">
      <slot name="icon" />
    </span>
    <span class="nav-link-text" :class="{ 'nav-link-text--hidden': collapsed }">
      {{ navText }}
    </span>

    <!-- Tooltip when collapsed -->
    <span v-if="collapsed" class="nav-tooltip">{{ navText }}</span>
  </router-link>
</template>

<script>
export default {
  name: 'SidenavCollapse',
  props: {
    to: { type: [Object, String], required: true },
    navText: { type: String, required: true },
    collapsed: { type: Boolean, default: false },
  },
}
</script>

<style scoped>
.nav-link-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 9px 12px;
  margin: 2px 8px;
  border-radius: 8px;
  color: rgba(255, 255, 255, 0.6);
  font-size: 0.82rem;
  font-weight: 500;
  text-decoration: none;
  transition: background 0.15s ease, color 0.15s ease;
  position: relative;
  white-space: nowrap;
}

.nav-link-item:hover {
  background: rgba(255, 255, 255, 0.08);
  color: rgba(255, 255, 255, 0.9);
}

.nav-link-item--active {
  background: #2563EB;
  color: #ffffff !important;
  box-shadow: 0 4px 14px rgba(37, 99, 235, 0.4);
}

.nav-link-icon {
  width: 20px;
  min-width: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.85rem;
}

.nav-link-text {
  overflow: hidden;
  transition: opacity 0.25s ease, width 0.25s ease;
  max-width: 160px;
}

.nav-link-text--hidden {
  opacity: 0;
  width: 0;
  max-width: 0;
}

/* Tooltip */
.nav-tooltip {
  position: absolute;
  left: calc(100% + 8px);
  top: 50%;
  transform: translateY(-50%);
  background: #0F172A;
  color: #fff;
  font-size: 0.75rem;
  font-weight: 500;
  padding: 4px 10px;
  border-radius: 6px;
  opacity: 0;
  pointer-events: none;
  white-space: nowrap;
  z-index: 100;
  transition: opacity 0.15s ease;
}

.nav-link-item:hover .nav-tooltip {
  opacity: 1;
}
</style>
